import { getUid } from "../../auth";
import {
  doc,
  getFirestore,
  collection,
  updateDoc,
  setDoc,
  arrayUnion,
  getDocs,
  getDoc,
  orderBy,
  query,
  arrayRemove,
  deleteDoc,
  runTransaction,
  where,
} from "firebase/firestore";
import { getCollectionRef, getDocRef } from "../utils";

export function getRecieverUidByChatId(chatId) {
  const { uid } = getUid();

  const recieverUid = chatId.split("_").find((item) => item !== uid);

  if (!recieverUid) {
    throw new Error();
  }
  return recieverUid;
}

export async function addOwnNewChatPetition({ chatId }) {
  const db = getFirestore();
  const { uid } = getUid();
  const recieverUid = getRecieverUidByChatId(chatId);
  const userDocRef = doc(db, `users/${uid}`);

  await updateDoc(userDocRef, {
    chatRequests: arrayUnion({
      chatId: chatId,
      from: uid,
      to: recieverUid,
    }),
  });
}

export async function subscribeToNewChat({ chatId }) {
  const db = getFirestore();
  const { uid } = getUid();
  const userDocRef = doc(db, `users/${uid}`);

  await updateDoc(userDocRef, {
    chats: arrayUnion(`${chatId}`),
  });
}

// aquí
export async function setNewChat({ chatId, content }) {
  const db = getFirestore();
  const { uid } = getUid();
  const colRef = collection(db, "chats");

  const recieverUid = getRecieverUidByChatId(chatId);

  const docRef = doc(colRef, `${chatId}`);

  await runTransaction(db, async (transaction) => {
    const timestamp = Date.now();

    transaction.set(docRef, {
      participants: [recieverUid, uid],
      timestamp: timestamp,
      accepted: {
        [uid]: true,
      },
      firstMessage: {
        from: recieverUid,
        to: uid,
        timestamp: timestamp,
        content: content,
        type: "text",
      },
      lastMessage: {
        from: recieverUid,
        to: uid,
        timestamp: timestamp,
        content: content,
        type: "text",
      },
    });
  });

  return docRef.id;
}

export async function addNewMessage({
  chatId,
  content,
  type,
  horizontal = null,
}) {
  const db = getFirestore();
  const { uid } = getUid();

  const chatRef = doc(db, `chats/${chatId}`);
  const messageCollection = collection(db, `chats/${chatId}/messages`);
  const messageDoc = doc(messageCollection);
  const recieverUid = getRecieverUidByChatId(chatId);

  let finalMessageContent = {
    from: uid,
    to: recieverUid,
    timestamp: Date.now(),
    content: content,
    type: type,
    read: false,
  };

  if (type === "image") {
    finalMessageContent = {
      ...finalMessageContent,
      horizontal: horizontal,
    };
  }

  await updateDoc(chatRef, {
    lastMessage: {
      from: uid,
      to: recieverUid,
      timestamp: Date.now(),
      content: content,
      type: type,
      read: {
        [uid]: true,
        [recieverUid]: false,
      },
    },
  });

  await setDoc(messageDoc, finalMessageContent);

  return messageDoc.id;
}

export async function setRecieverNotification({ chatId }) {
  const db = getFirestore();
  const recieverUid = getRecieverUidByChatId(chatId);
  const userDocRef = doc(db, `users/${recieverUid}`);
  const { uid } = getUid();

  await updateDoc(userDocRef, {
    chatRequests: arrayUnion({
      chatId: chatId,
      from: uid,
      to: recieverUid,
    }),
  });
}

// abe-aquí
export async function getChatArrayInfo({ chats }) {
  const db = getFirestore();
  let finalRes = {};

  const getUserData = async (chatId) => {
    const docRef = doc(db, `chats/${chatId}`);

    const data = await getDoc(docRef);

    if (data.exists()) {
      const finalData = data.data();
      const userUid = finalData.participants.find(
        (item) => item !== getUid().uid
      );

      const otherData = await getUserInfoChatList({ uid: userUid });

      return { ...finalData, ...otherData, chatId: docRef.id, uid: userUid };
    }
    return null;
  };

  let chatList = await Promise.allSettled(
    chats.map((chat) => {
      return getUserData(chat);
    })
  );

  for (let listItem of chatList) {
    const { status, value } = listItem;

    if (status === "fulfilled") {
      finalRes[value.chatId] = value;
    }
  }

  return finalRes;
}

export async function getUserInfoChatList({ uid }) {
  const db = getFirestore();
  const docRef = doc(db, `users/${uid}`);
  const data = await getDoc(docRef);

  if (data.exists()) {
    return data.data();
  } else {
    console.log("HOLA!");
  }
}

export async function getChatMessages({ chatId, firstMessageTimestamp }) {
  const db = getFirestore();
  const messageCollection = collection(db, `chats/${chatId}/messages`);

  const querySnapshot = await getDocs(messageCollection, {
    orderBy: "timestamp",
    // startAt: from,
    // endAt: to,
  });

  const messages = querySnapshot.docs.map((doc) => doc.data());

  return messages;
}

export async function getChatInfo({ chatId }) {
  const db = getFirestore();
  const docRef = doc(db, `chats/${chatId}`);
  const data = await getDoc(docRef);

  if (data.exists()) {
    return data.data();
  } else return null;
}

export function getChatDocRef({ chatId }) {
  const docRef = getDocRef(`chats/${chatId}`);

  return docRef;
}

export function getChatCollectionRef({ chatId, timestamp }) {
  const colRef = query(
    getCollectionRef(`chats/${chatId}/messages`),
    orderBy("timestamp", "asc"),
    where("timestamp", ">=", timestamp)
  );

  return colRef;
}

export async function updateMessageContent({ chatId, messageId, content }) {
  const db = getFirestore();
  const messageRef = doc(db, `chats/${chatId}/messages/${messageId}`);

  await updateDoc(messageRef, {
    content: content,
  });
}

export async function removeChatPetition({ chatId }) {
  const db = getFirestore();
  const { uid } = getUid();
  const recieverUid = getRecieverUidByChatId(chatId);
  const userDocRef = doc(db, `users/${uid}`);

  await updateDoc(userDocRef, {
    chatRequests: arrayRemove({
      chatId: chatId,
      from: recieverUid,
      to: uid,
    }),
  });
}

export async function removeChatPetitionReverse({ chatId }) {
  const db = getFirestore();
  const { uid } = getUid();
  const recieverUid = getRecieverUidByChatId(chatId);
  const userDocRef = doc(db, `users/${uid}`);

  await updateDoc(userDocRef, {
    chatRequests: arrayRemove({
      chatId: chatId,
      from: uid,
      to: recieverUid,
    }),
  });
}

export async function acceptChatPetition({ chatId }) {
  const db = getFirestore();
  const { uid } = getUid();
  const chatRef = doc(db, `chats/${chatId}`);
  const chatData = await getDoc(chatRef);

  if (chatData.exists()) {
    const data = chatData.data();

    await updateDoc(chatRef, {
      accepted: {
        ...data.accepted,
        [uid]: true,
      },
    });
  }
}

export async function validateChatRequests({ chatsRequests }) {
  const db = getFirestore();

  const promiseArr = [];
  const finalPromiseArr = [];
  const { uid } = getUid();

  for (let { chatId, from } of chatsRequests) {
    if (from === uid) {
      const chatRef = doc(db, `chats/${chatId}`);
      promiseArr.push(getDoc(chatRef));
    }
  }

  let chatsData = null;
  try {
    chatsData = await Promise.all(promiseArr);
  } catch (e) {
    console.log("AQUÏ CUELGUE");
  }

  for (let chatInfo of chatsData) {
    if (chatInfo.exists()) {
      const data = chatInfo.data();
      const chatId = chatInfo.id;

      const hasBeenAccepted = Object.values(data.accepted).reduce(
        (acc, item) => acc && item,
        true
      );

      if (hasBeenAccepted) {
        finalPromiseArr.push(removeChatPetition({ chatId }));
        finalPromiseArr.push(removeChatPetitionReverse({ chatId }));
        finalPromiseArr.push(subscribeToNewChat({ chatId }));
      }
    }
  }

  await Promise.all(finalPromiseArr);
}

export async function deleteChat({ chatId }) {
  const db = getFirestore();
  const chatRef = doc(db, `chats/${chatId}`);

  await deleteDoc(chatRef);
}

export async function setMessagesRead({ chatId }) {
  const db = getFirestore();
  const { uid } = getUid();
  const chatRef = doc(db, `chats/${chatId}`);
  const chatData = await getDoc(chatRef);

  if (chatData.exists()) {
    await updateDoc(chatRef, {
      lastMessage: {
        ...chatData.data().lastMessage,
        read: {
          [uid]: true,
        },
      },
    });
  }
}

export async function deleteChatDocument({ chatId }) {
  const db = getFirestore();
  const chatRef = doc(db, `chats/${chatId}`);

  await deleteDoc(chatRef);
}

export async function deleteChatFromChatList({ chatId }) {
  const db = getFirestore();
  const { uid } = getUid();

  const userDocRef = doc(db, `users/${uid}`);

  await updateDoc(userDocRef, {
    chats: arrayRemove(`${chatId}`),
  });

  return null;
}
